// CustomTooltip.jsx
import React from "react";
import { Tooltip, tooltipClasses } from "@mui/material";
import { useThemes } from "./Theme/theme";
import { fontWeight } from "@mui/system";


const CustomTooltip = ({ children, ...props }) => {
  const { theme } = useThemes();

  const tooltipStyle = {
    [`& .${tooltipClasses.tooltip}`]: {
    //   backgroundColor: theme?.palette?.primary?.main || "#333",
      backgroundColor:"#ffd700",
    //   color: theme?.palette?.primary?.contrastText || "#fff",
      fontWeight:600,
      color:"black",
      fontSize: "14px",
      padding: "10px 14px",
    //   borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      maxWidth: 220,
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: theme?.palette?.primary?.main || "#333",
    },
  };

  return (
    <Tooltip
    //   arrow
      {...props}
      componentsProps={{
        popper: {
          sx: tooltipStyle,
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
